import { Component, EventEmitter, Input, OnInit, Output, NgZone, inject } from '@angular/core';
import { AuxiliaresModule } from '../auxiliares.module';
import { HelperService } from '../servicios/helper.service';
import mapboxgl from 'mapbox-gl';
import { aplicarEtiquetasMapa } from '../mapbox/etiquetas-mapa';

@Component({
  selector: 'app-mapa-unico-punto',
  imports: [AuxiliaresModule],
  templateUrl: './mapa-unico-punto.component.html',
  styleUrl: './mapa-unico-punto.component.scss',
})
export class MapaUnicoPuntoComponent implements OnInit {
  private helper = inject(HelperService);
  private ngZone = inject(NgZone);

  @Input() point?: [number, number];
  @Output() pointsChange = new EventEmitter<[number, number]>();

  private map?: mapboxgl.Map;
  private marker?: mapboxgl.Marker;

  public nombreMap = 'MapaUnicoPuntoComponent';

  private async initMap(): Promise<void> {
    // Obtener posición inicial
    const position = this.point || (await this.getCurrentPosition());

    // CRÍTICO: Crear mapa FUERA de Angular Zone para evitar que Mapbox dispare change detection
    // El loop de renderizado interno de Mapbox usa requestAnimationFrame, MessageChannel y Promises
    // que quedarían patcheados por Zone.js si se crean dentro de Angular Zone
    this.ngZone.runOutsideAngular(() => {
      // Crear mapa de Mapbox
      this.map = new mapboxgl.Map({
        language: 'es', // Etiquetas del mapa base en español
        container: this.nombreMap,
        style: 'mapbox://styles/mapbox/streets-v12',
        center: position,
        zoom: 13,
      });
      aplicarEtiquetasMapa(this.map);

      // Agregar controles de navegación
      this.map.addControl(
        new mapboxgl.NavigationControl({
          showCompass: true,
          showZoom: true,
          visualizePitch: true,
        }),
        'bottom-right',
      );

      // Si hay un punto inicial, agregar marcador
      if (position) {
        this.addMarker(position);
      }

      // Manejar click en el mapa
      this.handleMapClick();
    });
  }

  /** Obtiene la posición actual del navegador */
  private async getCurrentPosition(): Promise<[number, number]> {
    if (navigator.geolocation) {
      return new Promise((resolve) => {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve([position.coords.longitude, position.coords.latitude]);
          },
          () => {
            // Default: Buenos Aires
            resolve([-58.3816, -34.6037]);
          },
        );
      });
    }
    // Default: Buenos Aires
    return [-58.3816, -34.6037];
  }

  private handleMapClick() {
    this.map?.on('click', (e) => {
      const lngLat: [number, number] = [e.lngLat.lng, e.lngLat.lat];
      this.point = lngLat;
      this.addMarker(lngLat);
      this.pointsChange.emit(this.point);
    });
  }

  private addMarker(coords: [number, number]) {
    // Eliminar marcador anterior si existe
    if (this.marker) {
      this.marker.remove();
    }

    // Crear nuevo marcador
    this.marker = new mapboxgl.Marker({
      color: '#FF0000',
    })
      .setLngLat(coords)
      .addTo(this.map!);
  }

  async ngOnInit(): Promise<void> {
    await this.initMap();
  }
}
